// Copyright (C) 2017-2023 Smart code 203358507

const Addons = require('./Addons');
const Board = require('./Board');
const Discover = require('./Discover');
const Library = require('./Library');
const MetaDetails = require('./MetaDetails');
const NotFound = require('./NotFound');
const Search = require('./Search');
const Settings = require('./Settings');
const Player = require('./Player');
const Intro = require('./Intro');

module.exports = {
    Addons,
    Board,
    Discover,
    Library,
    MetaDetails,
    NotFound,
    Search,
    Settings,
    Player,
    Intro
};
